import {
  HotelIcon,
  CustomerServicesIcon,
  RoomServiceIcon,
  ChatBubbleLeftIcon,
  MessageIcon,
  BookIcon,
  CheckIcon,
  ClockIcon,
  WifiIcon,
  FoodIcon,
  BreakfastIcon,
  ParkingIcon,
  LaundryIcon,
  PlaneArrivalIcon,
  PlaneDepartureIcon,
  ChildCarerIcon,
  UsersIcon,
  SuitcaseIcon,
  MapIcon,
  PhoneIcon,
  KeyIcon,
  CalendarIcon,
  TicketIcon,
  ShoppingBagIcon,
  EmergencyIcon,
  MoonIcon,
  ShieldIcon,
} from "components/Icons";

const MELHOUS_MODEL = "melhous";
const HOTEL_CONFIG_MODEL = "hotel.configuration";

const VIEW_HOME = "home";
const VIEW_HOTEL = "hotel";
const VIEW_ENGAGE = "engage";
const VIEW_REQUESTS = "requests";
const VIEW_PQRS = "pqrs";
const VIEW_APPEARANCE = "appearance";
const VIEW_QR = "qr";

const MELHOUS_PATH = "/dash/dashboard_melhous";

const PENDING_REQUESTS = {
  model: "melhous.request",
  domain: [["state", "=", "pending"]],
};

const ACTIVE_MESSAGES = {
  model: "melhous.message",
  domain: [["active", "=", true]],
};

const GUIDE_ITEMS = { model: "melhous.guide_item", domain: [] };

const ACTIVE_REQUEST_TYPES = {
  model: "melhous.request_type",
  domain: [["active", "=", true]],
};

const TAB_COUNTS = [{ id: VIEW_REQUESTS, ...PENDING_REQUESTS }];

const SETUP_COUNTS = [
  { id: "messages", ...ACTIVE_MESSAGES },
  { id: "guide", ...GUIDE_ITEMS },
  { id: "request_types", ...ACTIVE_REQUEST_TYPES },
];

const SETUP_FIELDS = ["id", "title", "phone", "primary_color", "link_melhous"];

const SETUP_QR_PRINTED_KEY = "melhous.setup.qr_printed";

const SETUP_STEPS = [
  {
    id: "hotel",
    title: "melhous.dash.setup.hotel",
    hint: "melhous.dash.setup.hotel_hint",
    action: "melhous.dash.setup.hotel_action",
    view: VIEW_HOTEL,
  },
  {
    id: "colors",
    title: "melhous.dash.setup.colors",
    hint: "melhous.dash.setup.colors_hint",
    action: "melhous.dash.setup.colors_action",
    view: VIEW_APPEARANCE,
  },
  {
    id: "link",
    title: "melhous.dash.setup.link",
    hint: "melhous.dash.setup.link_hint",
    action: "melhous.dash.setup.link_action",
    view: VIEW_ENGAGE,
  },
  {
    id: "care",
    title: "melhous.dash.setup.care",
    hint: "melhous.dash.setup.care_hint",
    action: "melhous.dash.setup.care_action",
    view: VIEW_ENGAGE,
  },
  {
    id: "qr",
    title: "melhous.dash.setup.qr",
    hint: "melhous.dash.setup.qr_hint",
    action: "melhous.dash.setup.qr_action",
    view: VIEW_QR,
    manual: true,
  },
];

const HOME_CARDS = [
  {
    id: "pending_requests",
    label: "melhous.dash.card.pending_requests",
    hint: "melhous.dash.card.pending_requests_hint",
    ...PENDING_REQUESTS,
    view: VIEW_REQUESTS,
    Icon: RoomServiceIcon,
  },
  {
    id: "active_messages",
    label: "melhous.dash.card.active_messages",
    hint: "melhous.dash.card.active_messages_hint",
    ...ACTIVE_MESSAGES,
    view: VIEW_ENGAGE,
    Icon: MessageIcon,
  },
  {
    id: "guide_items",
    label: "melhous.dash.card.guide_items",
    hint: "melhous.dash.card.guide_items_hint",
    ...GUIDE_ITEMS,
    view: VIEW_ENGAGE,
    Icon: BookIcon,
  },
  {
    id: "open_pqrs",
    label: "melhous.dash.card.open_pqrs",
    hint: "melhous.dash.card.open_pqrs_hint",
    model: "crm.customer_service",
    domain: [["state", "in", ["draft", "open"]]],
    view: VIEW_PQRS,
    Icon: ChatBubbleLeftIcon,
  },
];

const QR_FIELDS = ["id", "link_melhous"];

const QR_FEEDBACK_TIME = 3000;

const QR_LINKS = [
  {
    path: "",
    name: "qrMelhous",
    fileName: "qr-melhous-inicio.png",
    label: "melhous.dash.qr.melhous",
    hint: "melhous.dash.qr.melhous_hint",
  },
  {
    path: "/shops",
    name: "qrRestaurant",
    fileName: "qr-melhous-restaurantes.png",
    label: "melhous.dash.qr.restaurant",
    hint: "melhous.dash.qr.restaurant_hint",
  },
  {
    path: "/hotel",
    name: "qrHotel",
    fileName: "qr-melhous-hotel.png",
    label: "melhous.dash.qr.hotel",
    hint: "melhous.dash.qr.hotel_hint",
  },
];

const COLOR_FIELDS = [
  "primary_color",
  "secondary_color",
  "accent_color",
  "text_color",
  "surface_color",
  "border_color",
];

const SECTION_FIELDS = [
  "show_hotel",
  "show_restaurant",
  "show_pqrs",
  "show_reservation",
  "show_experiences",
];

const APPEARANCE_FIELDS = [...COLOR_FIELDS, ...SECTION_FIELDS, "logo_link"];

const HOTEL_DEFAULT_FIELDS = {
  title: "web_commercial_name",
  address: "web_address",
  phone: "web_phone",
  check_in: "check_in_time",
  check_out: "check_out_time",
  banner: "web_hero_image_url",
  logo: "web_logo_url",
  primary_color: "web_primary_color",
  secondary_color: "web_secondary_color",
  accent_color: "web_icon_color",
  desc: "web_long_description",
  text_color: "web_text_color",
};

const HOTEL_WEB_FIELDS = [
  ["web_hero_title", "melhous.hotel_hero_title", "text"],
  ["web_hero_subtitle", "melhous.hotel_hero_subtitle", "text"],
  ["web_badges", "melhous.hotel_badges", "text"],
  ["web_long_description", "melhous.hotel_about", "area"],
  ["children_policy", "melhous.hotel_children_policy", "area"],
  ["web_phone", "melhous.phone", "text"],
  ["web_email", "melhous.hotel_email", "text"],
  ["web_address", "melhous.address", "text"],
  ["web_city", "melhous.hotel_city", "text"],
  ["web_country", "melhous.hotel_country", "text"],
  ["web_map_embed_url", "melhous.hotel_map", "text"],
  ["web_social_whatsapp", "melhous.hotel_whatsapp", "text"],
  ["web_social_instagram", "melhous.hotel_instagram", "text"],
  ["web_social_facebook", "melhous.hotel_facebook", "text"],
];

const HOTEL_WEB_LISTS = [
  ["amenities.name", "melhous.hotel_amenities"],
  ["web_gallery.description", "melhous.hotel_gallery"],
];

const HOTEL_TIME_FIELDS = ["check_in", "check_out"];

const SITE_FIELDS = [
  ...new Set([
    "id",
    "main_title",
    "main_background",
    ...COLOR_FIELDS,
    ...Object.keys(HOTEL_DEFAULT_FIELDS),
  ]),
];

const SITE_DEFAULT_COLORS = {
  primary_color: "#17140f",
  secondary_color: "#b08d57",
  accent_color: "#b08d57",
  text_color: "#1f1c18",
  surface_color: "#f7f3ed",
  border_color: "#e3dbcf",
};

const PREVIEW_CARDS = [1, 2];

const STYLE_SITE_LAYOUT =
  "grid grid-cols-1 gap-6 lg:grid-cols-[minmax(0,1fr)_19rem]";

const STYLE_SITE_ASIDE = "w-full min-w-0 space-y-4 lg:sticky lg:top-4";

const STYLE_FOCUS_RING =
  "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-700";

const STYLE_ACTION_BUTTON = `rounded-md border border-neutral-300 bg-white px-3 py-2 text-sm font-medium text-neutral-700 hover:border-sky-900 ${STYLE_FOCUS_RING}`;

const STYLE_ACTION_BUTTON_PRIMARY = `rounded-md border border-sky-950 bg-sky-950 px-3 py-2 text-sm font-medium text-white hover:bg-sky-900 ${STYLE_FOCUS_RING}`;

const STYLE_QR_FRAME =
  "flex justify-center rounded-lg border border-neutral-200 bg-white p-4 [&>div]:pb-0 [&_a]:hidden [&>div>div]:scale-100!";

const HEX_COLOR_REGEX = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

const DEFAULT_PICKER_COLOR = "#ffffff";

const HOTEL_SCHEDULES = [
  { label: "melhous.dash.hotel.breakfast", start: "breakfast_start", end: "breakfast_end" },
  { label: "melhous.dash.hotel.lunch", start: "lunch_start", end: "lunch_end" },
  { label: "melhous.dash.hotel.dinner", start: "meal_start", end: "meal_end" },
];

const HOTEL_TEXT_FIELDS = [
  "title",
  "banner",
  "desc",
  "address",
  "url",
  "phone",
  "reception_phone",
  "reception_phone2",
  "reception_phone3",
  "wifi",
  "wifi_pass",
];

const HOTEL_FORM_TIME_FIELDS = [
  "check_in",
  "check_out",
  "breakfast_start",
  "breakfast_end",
  "lunch_start",
  "lunch_end",
  "meal_start",
  "meal_end",
];

const STYLE_SHEET_CARD =
  "rounded-lg border border-neutral-200 bg-white p-4 shadow-sm";

const STYLE_HOTEL_INPUT = `w-full rounded-md border border-neutral-300 bg-white px-3 py-2 text-sm text-neutral-800 ${STYLE_FOCUS_RING}`;

const HOTEL_SHEET_FIELDS = [
  "id",
  "title",
  "banner",
  "desc",
  "address",
  "url",
  "phone",
  "reception_phone",
  "reception_phone2",
  "reception_phone3",
  "wifi",
  "wifi_pass",
  "check_in",
  "check_out",
  "breakfast_start",
  "breakfast_end",
  "lunch_start",
  "lunch_end",
  "meal_start",
  "meal_end",
];

const ENGAGE_FIELDS = ["id", "link_melhous", "require_table_qr"];

const ENGAGE_LINK_FIELD = {
  name: "link_melhous",
  type: "text",
  label: "melhous.link_melhous",
  example: "melhous.dash.example.link",
};

const HOTEL_UTC_OFFSET = -5;

const DATETIME_INPUT_FORMAT = "YYYY-MM-DDTHH:mm";

const NEW_ITEM = "new";

const PICKER_LIMIT = 8;

const PICKER_DELAY = 300;

const PARENT_MELHOUS = "melhous";

const ACTIVE_FIELD = "active";

const IMAGE_SIZE_BANNER = "1920 × 1080";
const IMAGE_SIZE_GALLERY = "1600 × 1067";
const IMAGE_SIZE_SPECIAL = "1600 × 1000";

const SERVICE_ICONS = [
  { value: "CheckIcon", label: "melhous.dash.icon.check", Icon: CheckIcon },
  { value: "ClockIcon", label: "melhous.dash.icon.clock", Icon: ClockIcon },
  { value: "WifiIcon", label: "melhous.dash.icon.wifi", Icon: WifiIcon },
  { value: "FoodIcon", label: "melhous.dash.icon.food", Icon: FoodIcon },
  { value: "BreakfastIcon", label: "melhous.dash.icon.breakfast", Icon: BreakfastIcon },
  { value: "RoomServiceIcon", label: "melhous.dash.icon.room_service", Icon: RoomServiceIcon },
  { value: "LaundryIcon", label: "melhous.dash.icon.laundry", Icon: LaundryIcon },
  { value: "ParkingIcon", label: "melhous.dash.icon.parking", Icon: ParkingIcon },
  { value: "PlaneArrivalIcon", label: "melhous.dash.icon.plane_arrival", Icon: PlaneArrivalIcon },
  { value: "PlaneDepartureIcon", label: "melhous.dash.icon.plane_departure", Icon: PlaneDepartureIcon },
  { value: "CustomerServicesIcon", label: "melhous.dash.icon.customer_service", Icon: CustomerServicesIcon },
  { value: "ChildCarerIcon", label: "melhous.dash.icon.child_carer", Icon: ChildCarerIcon },
  { value: "UsersIcon", label: "melhous.dash.icon.users", Icon: UsersIcon },
  { value: "SuitcaseIcon", label: "melhous.dash.icon.suitcase", Icon: SuitcaseIcon },
  { value: "MapIcon", label: "melhous.dash.icon.map", Icon: MapIcon },
  { value: "PhoneIcon", label: "melhous.dash.icon.phone", Icon: PhoneIcon },
  { value: "KeyIcon", label: "melhous.dash.icon.key", Icon: KeyIcon },
  { value: "CalendarIcon", label: "melhous.dash.icon.calendar", Icon: CalendarIcon },
  { value: "TicketIcon", label: "melhous.dash.icon.ticket", Icon: TicketIcon },
  { value: "ShoppingBagIcon", label: "melhous.dash.icon.shopping", Icon: ShoppingBagIcon },
  { value: "EmergencyIcon", label: "melhous.dash.icon.emergency", Icon: EmergencyIcon },
  { value: "MoonIcon", label: "melhous.dash.icon.moon", Icon: MoonIcon },
  { value: "ShieldIcon", label: "melhous.dash.icon.shield", Icon: ShieldIcon },
  { value: "HotelIcon", label: "melhous.dash.icon.hotel", Icon: HotelIcon },
];

const SEQUENCE_FIELD = {
  name: "sequence",
  type: "number",
  label: "melhous.dash.list.order",
  hint: "melhous.dash.list.order_hint",
};

const ACTIVE_FORM_FIELD = {
  name: ACTIVE_FIELD,
  type: "boolean",
  label: "melhous.message.active",
  hint: "melhous.dash.list.active_hint",
  default: true,
};

const ACTIVE_LIST = {
  domain: [[ACTIVE_FIELD, "in", [true, false]]],
};

const LIST_ITEM_SERVICES = {
  id: "item_services",
  model: "melhous.item_service",
  parentField: "service",
  title: "melhous.item_service",
  hint: "melhous.dash.list.item_services_hint",
  add: "melhous.dash.list.item_services_add",
  empty: "melhous.dash.list.item_services_empty",
  blocked: "melhous.dash.list.item_services_blocked",
  titleField: "title",
  detailField: "description",
  iconField: "icon",
  fields: [
    {
      name: "title",
      type: "text",
      label: "melhous.item_service.title",
      example: "melhous.dash.example.item_title",
      required: true,
    },
    { name: "description", type: "textarea", label: "melhous.item_service.description" },
    { name: "icon", type: "icon", label: "melhous.item_service.icon", wide: true },
  ],
};

const LIST_SERVICES = {
  id: "services",
  model: "melhous.service",
  parentField: PARENT_MELHOUS,
  title: "melhous.services",
  hint: "melhous.dash.list.services_hint",
  add: "melhous.dash.list.services_add",
  empty: "melhous.dash.list.services_empty",
  titleField: "title",
  detailField: "description",
  iconField: "icon",
  children: LIST_ITEM_SERVICES,
  fields: [
    {
      name: "title",
      type: "text",
      label: "melhous.service.title",
      example: "melhous.dash.example.service_title",
      required: true,
    },
    {
      name: "button",
      type: "text",
      label: "melhous.dash.list.service_button",
      hint: "melhous.dash.list.service_button_hint",
      example: "melhous.dash.example.link",
    },
    {
      name: "description",
      type: "textarea",
      label: "melhous.service.description",
      example: "melhous.dash.example.service_description",
      wide: true,
    },
    { name: "icon", type: "icon", label: "melhous.service.icon", wide: true },
  ],
};

const LIST_OTHER_SERVICES = {
  id: "other_services",
  model: "melhous.other_services",
  parentField: PARENT_MELHOUS,
  title: "melhous.other_services",
  hint: "melhous.dash.list.other_services_hint",
  add: "melhous.dash.list.other_services_add",
  empty: "melhous.dash.list.other_services_empty",
  titleField: "title",
  detailField: "description",
  iconField: "icon",
  fields: [
    {
      name: "title",
      type: "text",
      label: "melhous.other_services.title",
      example: "melhous.dash.example.other_title",
      required: true,
    },
    {
      name: "description",
      type: "textarea",
      label: "melhous.other_services.description",
      example: "melhous.dash.example.other_description",
    },
    { name: "icon", type: "icon", label: "melhous.other_services.icon", wide: true },
  ],
};

const LIST_SPECIAL_SERVICES = {
  id: "special_services",
  model: "melhous.special_services",
  parentField: PARENT_MELHOUS,
  title: "melhous.special_services",
  hint: "melhous.dash.list.special_services_hint",
  add: "melhous.dash.list.special_services_add",
  empty: "melhous.dash.list.special_services_empty",
  titleField: "title",
  detailField: "description",
  iconField: "icon",
  imageField: "image",
  fields: [
    {
      name: "title",
      type: "text",
      label: "melhous.special_services.title",
      example: "melhous.dash.example.special_title",
      required: true,
    },
    {
      name: "description",
      type: "textarea",
      label: "melhous.special_services.description",
      hint: "melhous.dash.list.special_description_hint",
      example: "melhous.dash.example.special_description",
    },
    {
      name: "image",
      type: "image",
      label: "melhous.special_services.image",
      size: IMAGE_SIZE_SPECIAL,
      wide: true,
    },
    { name: "icon", type: "icon", label: "melhous.special_services.icon", wide: true },
  ],
};

const LIST_GALLERY = {
  id: "gallery_areas",
  model: "melhous.gallery_areas",
  parentField: "configuration",
  hint: "melhous.dash.list.gallery_hint",
  add: "melhous.dash.list.gallery_add",
  empty: "melhous.dash.list.gallery_empty",
  titleField: "title",
  detailField: "desc",
  imageField: "image",
  fields: [
    {
      name: "image",
      type: "image",
      label: "melhous.gallery_areas.image",
      size: IMAGE_SIZE_GALLERY,
      required: true,
      wide: true,
    },
    {
      name: "title",
      type: "text",
      label: "melhous.gallery_areas.title",
      example: "melhous.dash.example.gallery_title",
    },
    {
      name: "desc",
      type: "textarea",
      label: "melhous.gallery_areas.desc",
      example: "melhous.dash.example.gallery_description",
    },
  ],
};

const HOTEL_SERVICE_LISTS = [
  LIST_SERVICES,
  LIST_OTHER_SERVICES,
  LIST_SPECIAL_SERVICES,
];

const LIST_GUIDE = {
  id: "guide_items",
  model: "melhous.guide_item",
  parentField: PARENT_MELHOUS,
  title: "melhous.dash.block.guide",
  hint: "melhous.dash.block.guide_hint",
  add: "melhous.dash.list.guide_add",
  empty: "melhous.dash.list.guide_empty",
  titleField: "title",
  detailField: "description",
  tagFields: ["section"],
  fields: [
    {
      name: "section",
      type: "select",
      label: "melhous.guide_item.section",
      required: true,
      default: "hotel",
      options: [
        { value: "hotel", label: "melhous.guide_item.hotel" },
        { value: "nearby", label: "melhous.guide_item.nearby" },
      ],
    },
    {
      name: "title",
      type: "text",
      label: "melhous.guide_item.title",
      example: "melhous.dash.example.guide_title",
      required: true,
    },
    {
      name: "schedule",
      type: "text",
      label: "melhous.guide_item.schedule",
      example: "melhous.dash.example.guide_schedule",
    },
    {
      name: "link",
      type: "text",
      label: "melhous.guide_item.link",
      example: "melhous.dash.example.link",
    },
    {
      name: "description",
      type: "textarea",
      label: "melhous.guide_item.description",
      wide: true,
    },
    SEQUENCE_FIELD,
  ],
};

const LIST_MESSAGES = {
  ...ACTIVE_LIST,
  id: "messages",
  model: "melhous.message",
  parentField: PARENT_MELHOUS,
  title: "melhous.dash.block.messages",
  hint: "melhous.dash.block.messages_hint",
  add: "melhous.dash.list.messages_add",
  empty: "melhous.dash.list.messages_empty",
  titleField: "title",
  detailField: "body",
  tagFields: ["kind"],
  fields: [
    {
      name: "title",
      type: "text",
      label: "melhous.message.title",
      example: "melhous.dash.example.message_title",
      required: true,
    },
    {
      name: "kind",
      type: "select",
      label: "melhous.message.kind",
      required: true,
      default: "info",
      options: [
        { value: "info", label: "melhous.message.info" },
        { value: "promo", label: "melhous.message.promo" },
        { value: "alert", label: "melhous.message.alert" },
      ],
    },
    { name: "body", type: "textarea", label: "melhous.message.body", wide: true },
    { name: "start", type: "datetime", label: "melhous.message.start" },
    {
      name: "end",
      type: "datetime",
      label: "melhous.message.end",
      hint: "melhous.dash.list.message_dates_hint",
      after: "start",
    },
    ACTIVE_FORM_FIELD,
  ],
};

const LIST_REQUEST_TYPES = {
  ...ACTIVE_LIST,
  id: "request_types",
  model: "melhous.request_type",
  parentField: PARENT_MELHOUS,
  title: "melhous.dash.block.request_types",
  hint: "melhous.dash.block.request_types_hint",
  add: "melhous.dash.list.request_types_add",
  empty: "melhous.dash.list.request_types_empty",
  titleField: "name",
  tagFields: ["scope"],
  fields: [
    {
      name: "name",
      type: "text",
      label: "melhous.request_type.name",
      example: "melhous.dash.example.request_name",
      required: true,
    },
    {
      name: "scope",
      type: "select",
      label: "melhous.request_type.scope",
      required: true,
      default: "both",
      options: [
        { value: "table", label: "melhous.request_type.table" },
        { value: "room", label: "melhous.request_type.room" },
        { value: "both", label: "melhous.request_type.both" },
      ],
    },
    SEQUENCE_FIELD,
    ACTIVE_FORM_FIELD,
  ],
};

const LIST_RECOMMENDATIONS = {
  ...ACTIVE_LIST,
  id: "recommendations",
  model: "melhous.recommendation",
  parentField: PARENT_MELHOUS,
  title: "melhous.dash.block.recommendations",
  hint: "melhous.dash.block.recommendations_hint",
  add: "melhous.dash.list.recommendations_add",
  empty: "melhous.dash.list.recommendations_empty",
  titleField: "name",
  detailField: "message",
  fields: [
    {
      name: "name",
      type: "text",
      label: "melhous.recommendation.name",
      example: "melhous.dash.example.recommendation_name",
      required: true,
    },
    {
      name: "message",
      type: "text",
      label: "melhous.recommendation.message",
      example: "melhous.dash.example.recommendation_message",
    },
    {
      name: "trigger_category",
      type: "record",
      label: "melhous.recommendation.trigger_category",
      model: "product.category",
      domain: [["accounting", "=", false]],
    },
    {
      name: "trigger_product",
      type: "record",
      label: "melhous.recommendation.trigger_product",
      model: "product.template",
      domain: [["salable", "=", true]],
    },
    {
      name: "products",
      type: "records",
      label: "melhous.recommendation.products",
      hint: "melhous.dash.list.recommendation_products_hint",
      model: "product.template",
      domain: [["salable", "=", true]],
      wide: true,
    },
    SEQUENCE_FIELD,
    ACTIVE_FORM_FIELD,
  ],
};

const ENGAGE_LISTS = [
  LIST_GUIDE,
  LIST_MESSAGES,
  LIST_REQUEST_TYPES,
  LIST_RECOMMENDATIONS,
];

export {
  HOTEL_TEXT_FIELDS,
  HOTEL_FORM_TIME_FIELDS,
  STYLE_HOTEL_INPUT,
  STYLE_SHEET_CARD,
  HOTEL_SCHEDULES,
  HOTEL_SERVICE_LISTS,
  HOTEL_SHEET_FIELDS,
  LIST_GALLERY,
  ENGAGE_FIELDS,
  ENGAGE_LINK_FIELD,
  ENGAGE_LISTS,
  HOTEL_UTC_OFFSET,
  DATETIME_INPUT_FORMAT,
  NEW_ITEM,
  ACTIVE_FIELD,
  PICKER_LIMIT,
  PICKER_DELAY,
  IMAGE_SIZE_BANNER,
  SERVICE_ICONS,
  COLOR_FIELDS,
  SECTION_FIELDS,
  APPEARANCE_FIELDS,
  HOTEL_CONFIG_MODEL,
  HOTEL_DEFAULT_FIELDS,
  HOTEL_WEB_FIELDS,
  HOTEL_WEB_LISTS,
  HOTEL_TIME_FIELDS,
  SITE_FIELDS,
  SITE_DEFAULT_COLORS,
  PREVIEW_CARDS,
  STYLE_SITE_LAYOUT,
  STYLE_SITE_ASIDE,
  STYLE_FOCUS_RING,
  STYLE_ACTION_BUTTON,
  STYLE_ACTION_BUTTON_PRIMARY,
  STYLE_QR_FRAME,
  HEX_COLOR_REGEX,
  DEFAULT_PICKER_COLOR,
  MELHOUS_MODEL,
  VIEW_HOME,
  VIEW_HOTEL,
  VIEW_ENGAGE,
  VIEW_REQUESTS,
  VIEW_PQRS,
  VIEW_APPEARANCE,
  VIEW_QR,
  MELHOUS_PATH,
  TAB_COUNTS,
  SETUP_COUNTS,
  SETUP_FIELDS,
  SETUP_QR_PRINTED_KEY,
  SETUP_STEPS,
  HOME_CARDS,
  QR_FEEDBACK_TIME,
  QR_FIELDS,
  QR_LINKS,
};
